/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, pxToRem, mediaQuery, imageTypes, color, centerAbsolutely } from 'utils/styles';
import { url } from 'utils/urls';
import { aniFrameCountdownBarInitial } from 'components/content/shared/questionset/shared/animations/frame_countdownbar/initial';
import { aniFrameCountdownBarResult } from 'components/content/shared/questionset/shared/animations/frame_countdownbar/result';
import { aniProgressBarShareBottomInitial } from 'components/content/shared/questionset/shared/animations/progressbar_share_bottom/initial';
import { aniProgressBarShareBottomResult } from 'components/content/shared/questionset/shared/animations/progressbar_share_bottom/result';
import { aniFrameRewardOnlyInitial } from 'components/content/shared/questionset/shared/animations/frame_rewardonly/initial';
import { aniFrameRewardOnlyResult } from 'components/content/shared/questionset/shared/animations/frame_rewardonly/result';
import { aniRewardOnlyInitial } from 'components/content/shared/questionset/shared/animations/rewardonly/initial';
import { aniRewardOnlyResult } from 'components/content/shared/questionset/shared/animations/rewardonly/result';
import { aniQuestionRewardOnlyResult } from 'components/content/shared/questionset/shared/animations/question/result_rewardonly';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TEXT 1 QUESTION TYPE STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
    resultelements: {},
    answerset: {},
    typeset: {
        width: '100%',
        height: '100%',

        // ------ QUESTION ----- //
        '& .question': {
            transform: 'translate3d(-100%, 0, 0)', // pull off screen to start
            animationName: 'slideInLeft',
            animationDelay: '.1s',
            animationDuration: '.3s',
            animationFillMode: 'forwards'
        },

        // ------ ANSWER SET ----- //
        '& .answerset': {
            '& ul': {
                width: '100%',
                height: 'auto',
                extend: centerAbsolutely,
            },
            '& .answer': {
                display: 'block',
                marginBottom: pxToRem(6),
                '& .background': {
                    transition: 'background .3s linear 0s',
                },
                '&:last-child': {
                    marginBottom: '0'
                },
                '&:hover': {
                    '& .background': {
                        background: 'rgba(255,255,255,.7)'
                    }
                },

                opacity: '0',
                animationName: 'fadeInLeft',
                animationDelay: '0s',
                animationDuration: '.3s',
                animationFillMode: 'forwards',

                '&:nth-child(1)': { animationDelay: '.9s' }, // delay each child animation slightly
                '&:nth-child(2)': { animationDelay: '1.1s' },
                '&:nth-child(3)': { animationDelay: '1.3s' },
                '&:nth-child(4)': { animationDelay: '1.5s' }
            },
            // used to showcase correct answer to user (animations otherwise are too difficult)
            '& .showcorrectanswer': {
                position: 'absolute',
                top: hasRewardsComponent => hasRewardsComponent ? '26%' : '30%',
                left: '0',
                opacity: '0',
                zIndex: '-1',
                lineHeight: '1',
                '& .icon': {
                    verticalAlign: 'middle',
                    extend: imageTypes.icon,
                    backgroundImage: `url(${url.image.app}/icon-check.png)`,
                    width: pxToEm(10),
                    height: pxToEm(10),
                    marginRight: pxToEm(5)
                },
                '& .text': {
                    verticalAlign: 'middle',
                    fontSize: pxToEm(12)
                }
            },
            // amount of answers change the styles (ex 2 answers vs 4 answers)
            '&.answeramount-2': {
                height: hasRewardsComponent => hasRewardsComponent ? '65%' : '60%',
                '& ul': { top: '29%' },
                '& .showcorrectanswer': {
                    top: '31%',
                }
            },
            '&.answeramount-3': {
                height: hasRewardsComponent => hasRewardsComponent ? '65%' : '60%',
                '& ul': { top: '38%' },
                '& .showcorrectanswer': {
                    top: '27.5%',
                }
            }
        },

        // !!!!!!!!!!!!!!!!!!! ~~~~~~~~~~~~~~~~~~~~~~~ ANIMATIONS ~~~~~~~~~~~~~~~~~~~~~~~ !!!!!!!!!!!!!!!!!!! //
        extend: [aniProgressBarShareBottomInitial],
        // *** INITIAL STATE *** //
        '&.initial': {
            extend: [aniFrameCountdownBarInitial],
        },
        // *** RESULT STATE *** //
        '&.result': {
            extend: [aniFrameCountdownBarResult, aniProgressBarShareBottomResult],
            '& .answerset': {
                '& .showcorrectanswer': {
                    zIndex: '2',
                    animationName: 'fadeInLeft',
                    animationDelay: '2.8s',
                    animationDuration: '.3s',
                    animationFillMode: 'forwards'
                },
                '& .answer': {
                    opacity: '1',
                    '& .background': {
                        background: '#fff'
                    },
                    '&.selected-true': {
                        '& .uniqueanswer': { transition: 'transform .3s linear 1.2s' }, // ********* this transition along with the transforms below causes text to blur (when media query fontSize percentage used on parent to scale elements)
                        '&:nth-child(1)': { '& .uniqueanswer': { transform: `translateY(-${pxToEm(0)})` } },
                        '&:nth-child(2)': { '& .uniqueanswer': { transform: `translateY(-${pxToEm(35)})` } },
                        '&:nth-child(3)': { '& .uniqueanswer': { transform: `translateY(-${pxToEm(35*2)})` } },
                        '&:nth-child(4)': { '& .uniqueanswer': { transform: `translateY(-${pxToEm(35*3)})` } },
                        '& .text': { transition: 'color .3s linear 0s' },
                        '&.correct': { '& .text': { color: color.green } },
                        '&.incorrect': { '& .text': { color: color.red } },
                    },
                    '&.selected-false': {
                        '& .uniqueanswer': {
                            animationName: 'fadeOutRight',
                            animationDelay: '.7s !important',
                            animationDuration: '.6s',
                            animationFillMode: 'forwards'
                        },
                        '& .desc': {
                            transition: 'transform .3s linear 0s',
                            transform: 'scale(.9)',
                            '& .background': {
                                transition: 'background .3s linear 0s',
                                background: 'rgba(255,255,255,.6)'
                            }
                        }
                    }
                }
            }
        },
        // *** REWARDS STATE *** //
        '&.rewards': {
            // extend: [aniFrameCountdownBarResult, aniQuestionResult, aniProgressBarShareTopResult],

            '& .answerset, .resultelements, .question': {
                // removes text when shrinking the images
                display: 'none'
            },
            '& .rewardsmessage': { // This class name is in RewardsMessage component! It's a RewardsMessage wrapper div.
                display: 'block',
                width: '100%',
                height: '100%',
                opacity: '0', // pull off screen to start
                animationName: 'fadeIn',
                animationDelay: '0s',
                animationDuration: '.3s',
                animationFillMode: 'forwards'
            }
        },

        // ***** REMOVE ANIMATIONS IF QUESTIONNAIRE ***** //
        '&.parentContentType-questionnaire': {
            extend: [aniRewardOnlyInitial],
            '&.initial': {
                extend: [aniFrameRewardOnlyInitial],
            },
            '&.result': {
                extend: [aniFrameRewardOnlyResult, aniRewardOnlyResult, aniQuestionRewardOnlyResult],
            }
            // '& .question': {
            //     transform: 'none !important',
            //     animationName: 'none !important',
            //     opacity: '1 !important'
            // },
            // '& .answerset .answer': {
            //     transform: 'none !important',
            //     animationName: 'none !important',
            //     opacity: '1 !important'
            // }
        }
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.wide]: {
        typeset: { '& .answerset': { fontSize: '105%' } }
    },
    [mediaQuery.thin]: {
        // typeset: { '& .answerset': { fontSize: '90%' } }
        typeset: { '& .answerset': { '& .answer': { '& .text': { fontSize: '80%', lineHeight: '1' } } } }
    }
};


